import { render, staticRenderFns } from "./SecurityPopUp.vue?vue&type=template&id=37d90afc&"
import script from "./SecurityPopUp.vue?vue&type=script&lang=js&"
export * from "./SecurityPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d90afc')) {
      api.createRecord('37d90afc', component.options)
    } else {
      api.reload('37d90afc', component.options)
    }
    module.hot.accept("./SecurityPopUp.vue?vue&type=template&id=37d90afc&", function () {
      api.rerender('37d90afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/security/SecurityPopUp.vue"
export default component.exports